import React from 'react'
import { useLoanContext } from '@/contexts/LoanContext'
import LayoutRow from '@/components/layout/LayoutRow'
import BorrowerPreviewCard from '@/components/loanAppDetails/loan-borrowers-preview/borrower-preview-card'
import { generatePath, Link } from 'react-router-dom'
import { navigationLinking } from '@/services/navigation'
import { useIntl } from 'react-intl'
import extractBorrowerAndCoBorrowerFromLoansAndContacts from '@/pages/protected/pipeline/utils/extract-borrower-and-coborrower-from-loans-and-contacts'

function LoanBorrowersPreview() {
	const { loan } = useLoanContext()
	const { formatMessage } = useIntl()

	if (!loan) return null

	const { userLoans, contacts } = loan

	const { borrower, coBorrower } =
		extractBorrowerAndCoBorrowerFromLoansAndContacts(
			userLoans,
			contacts
		)

	const hasMorePeople =
		loan.userLoans.length > 2 || loan.contacts.length > 2

	const sumBorrowerCoborrower =
		(borrower ? 1 : 0) + (coBorrower ? 1 : 0)

	const morePeopleAmount =
		loan.userLoans.length +
		loan.contacts.length -
		sumBorrowerCoborrower

	return (
		<LayoutRow className="mb-8">
			<LayoutRow className="flex flex-col gap-5 md:flex-row">
				{borrower && (
					<BorrowerPreviewCard
						title={formatMessage({
							id: 'pipeline.expanded_row.borrower',
						})}
						name={borrower?.name}
						phone={borrower?.phone}
						email={borrower?.email}
					/>
				)}
				{coBorrower && (
					<BorrowerPreviewCard
						title={formatMessage({
							id: 'pipeline.expanded_row.co_borrower',
						})}
						name={coBorrower?.name}
						phone={coBorrower?.phone}
						email={coBorrower?.email}
					/>
				)}
				{hasMorePeople && (
					<Link
						to={generatePath(`/${navigationLinking.People}`, {
							loanId: loan.id,
						})}
						className="underline flex-shrink-0"
					>
						+ {morePeopleAmount}{' '}
						{formatMessage({ id: 'global.more' })}
					</Link>
				)}
			</LayoutRow>
		</LayoutRow>
	)
}

export default LoanBorrowersPreview
